import type { HelpFile } from '../../types/help'
import { OnboardingWizardTestIds } from '../../../testids/OnboardingWizardTestIds'

export const onboardingWizardHelp: HelpFile = {
  docPage: '/docs/onboarding/wizard',
  texts: {
    [OnboardingWizardTestIds.onboardingWizardPage]: 'Schritt-für-Schritt-Assistent zum Onboarding einer neuen Partei und Identität — Kennungen, Attribute und Beziehungen.',
    [OnboardingWizardTestIds.btnNext]: 'Zum nächsten Schritt weiter — Pflichtfelder des aktuellen Schritts werden zuerst geprüft.',
    [OnboardingWizardTestIds.btnPrevious]: 'Zum vorherigen Schritt zurück — eingegebene Daten bleiben erhalten.',
    [OnboardingWizardTestIds.btnCancel]: null,
    [OnboardingWizardTestIds.btnSubmit]: null,
  },
}
